//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    VIDFLEET_CONFIGURATION_UPLOAD_MODE_LOAD,
    VIDFLEET_CONFIGURATION_UPLOAD_MODE_SAVE
} from 'Redux/actionTypes';

//```import global actions
import {
    vidfleetConfigurationUploadModeLoadDataResult,
    vidfleetConfigurationUploadModeSaveResult,
} from 'Redux/actions';

/**
 * Method for get customer data for Server
 * @param {object} payload Payload with info
 */
function* vidFleetConfigurationUploadModeLoad({ payload }) {
    try {

        let result = {}
        let { esn, devices, mode } = payload;

        let QUERY_EVENT_UPLOAD_MODE = `
            query getEventUploadMode($esn: String){
                result: getEventUploadMode(esn: $esn)
            }
        `

        let eventUploadMode = yield call(
            clientQuery,
            QUERY_EVENT_UPLOAD_MODE,
            {},
            endpoints.GRAPHQL_GENERAL,
        );

        if (eventUploadMode?.result) {
            let resultGeneral = JSON.parse(eventUploadMode?.result)
            result.fleetConfig = resultGeneral
        }

        if (mode === "Single") {
            if (esn) {

                let QUERY_EVENT_UPLOAD_MODE_BY_ESN = `
                    query getEventUploadMode($esn: String){
                        result: getEventUploadMode(esn: $esn)
                    }
                `

                let eventUploadModeByEsn = yield call(
                    clientQuery,
                    QUERY_EVENT_UPLOAD_MODE_BY_ESN,
                    {
                        esn: esn
                    },
                    endpoints.GRAPHQL_GENERAL,
                );

                if (eventUploadModeByEsn?.result) {
                    let resultSingle = JSON.parse(eventUploadModeByEsn?.result)
                    result.deviceConfig = resultSingle;
                }
            }
        } else {
            result.devices = devices;
        }
        result.mode = mode;
        yield put(vidfleetConfigurationUploadModeLoadDataResult(result))
    } catch (exc) {

        //```call action for return
        yield put(vidfleetConfigurationUploadModeLoadDataResult({ error: exc }));



        //```catch error
        ExceptionManager(exc,
            "Modules/vidfleet/.components/configurationUploadMode/redux/saga/",
            "vidFleetConfigurationUploadModeLoad")
    }
}


function* vidfleetConfigurationUploadModeSave({ payload }) {

    try {

        let { config, esns, deviceIds, oldConfig, applyScopes, verificationCode } = payload;

        let data = null;

        let QUERY = `
            mutation updateVidFleetEventUploadMode ($eventUploadMode: AWSJSON!, $scopes: [enumVidFleetScope]!, $unitIds: [Int]!, $verificationCode: String) {
            result: updateVidFleetEventUploadMode (eventUploadMode: $eventUploadMode, scopes: $scopes, unitIds: $unitIds, verificationCode: $verificationCode)
            } 
        `;

        data = yield call(
            clientMutation,
            QUERY,
            {
                eventUploadMode: JSON.stringify(config),
                scopes: applyScopes,
                unitIds: deviceIds,
                verificationCode: verificationCode
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(vidfleetConfigurationUploadModeSaveResult(data));
    } catch (exc) {

        yield put(vidfleetConfigurationUploadModeSaveResult({ error: exc }));


        ExceptionManager(
            exc,
            "Modules/vidfleet/.components/configurationUploadMode/redux/saga/",
            "vidfleetConfigurationUploadModeSave"
        );

    }
}

function* watchMethods() {
    yield takeEvery(VIDFLEET_CONFIGURATION_UPLOAD_MODE_LOAD, vidFleetConfigurationUploadModeLoad);
    yield takeEvery(VIDFLEET_CONFIGURATION_UPLOAD_MODE_SAVE, vidfleetConfigurationUploadModeSave);
}

/**
 * Export for global saga
 */
export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}